export default function truncate(text, stop, clamp) {
  let val = ''

  if (text) {
    val = text.slice(0, stop) + (stop < text.length ? clamp : '')
  }

  return val
}
